import React from 'react';

const BusinessPlanFooter = () => (
  <div className="col-md-9 business-footer-wrapper">
    <div className="graph-description">
      Take Georgia for example. In 2017, 94,715 FormSwift users from Georgia
      created business plans on our website. With an exit rate of 31.1% from
      the page, the total number of users who completed their business plans
      totaled 65,069 individuals. The total population of Georgia as of 2016 was
      472,522, so per 100,000 people, we could determine that 13,771 created
      business plans. This was the highest total of all states, making Georgia
      the most entrepreneurial in 2017.
      <div>
        New Jersey was the least entrepreneurial state of 2017 with 277 business
        plan completions per 100,000 people.
      </div>
    </div>
    <div className="graph-sources">
      Sources: <br />
      Internal Data - Google Analytics <br />
      US Census Bureau <br />
    </div>
  </div>
);

export default BusinessPlanFooter;



// WEBPACK FOOTER //
// ./src-react/UsaMap/footers/BusinessPlanFooter.jsx